// NOTE: only used for frontend, _not_ for SSR
import PropTypes from 'prop-types'

import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { Router } from 'react-router'
import { createBrowserHistory } from 'history'
import { hot } from 'react-hot-loader'

import { setLocation } from '../../reducers/location'
import { requestWpPageDataSuccess } from '../../reducers/wpData'

import { getWpPageData } from '../../utils/wordpress'

import routes from '../routes/'

const browserHistory = createBrowserHistory()

class Root extends Component {
  componentDidMount () {
    const { store } = this.props
    this._unlisten = browserHistory.listen(location => {
      store.dispatch(setLocation(location))
      // FROM: https://github.com/reactjs/react-router/issues/2144#issuecomment-150939358
      // Use setTimeout to make sure this runs after React Router's own listener
      setTimeout(() => {
        // Keep default behavior of restoring scroll position when user:
        // - clicked back button
        // - clicked on a link that programmatically calls `history.goBack()`
        // - manually changed the URL in the address bar (here we might want
        // to scroll to top, but we can't differentiate it from the others)
        if (location.action === 'POP') {
          return
        }
        // if there's a hash in the new url, and it matches an element on the page,
        // scroll to the element
        const scrollToSelector = window.location.hash
        const scrollToElement = scrollToSelector && document.querySelector(scrollToSelector)
        if (scrollToElement) {
          scrollToElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
          return
        }
        // In all other cases, scroll to top
        window.scrollTo(0, 0)
      })
    })

    // pre-load wp page data for important routes
    routes[0].routes
      .filter(r => r.preloadWpDataClientSide)
      .forEach(({ wpPageId }) => {
        if (!store.getState().wpData.pages[wpPageId]) {
          getWpPageData(wpPageId).then(pageData =>
            store.dispatch(requestWpPageDataSuccess(pageData))
          )
        }
      })
  }
  componentWillUnmount () {
    if (typeof this._unlisten === 'function') {
      this._unlisten()
    }
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <Router history={browserHistory}>{renderRoutes(routes)}</Router>
      </Provider>
    )
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired
}

export default hot(module)(Root)
